import { toPartialQueryString } from '@/utils/parsers/QueryString'
import { IFilterList } from '@/utils/interfaces/FilterListInterface'
import {
    IAuditEntityListEnumDescription,
    IAuditStatusListEnumDescription,
    IAuditSeverityListEnumDescription,
    IAuditIntegrationSourceEnumDescription
} from '@/audit/interfaces/AuditInterfaces'
import { IDateRange } from '@/utils/interfaces/DateRangeInterface'
import { 
    EntityEnum, 
    IntegrationSourceEnum,
    getEntityEnumDescription,
} from '@c2b/muven-commons'

import { AuditStatusEnum, AuditSeverityEnum,  getAuditSeverityEnumDescription, getAuditStatusEnumDescription } from '@c2b/commons'

export class AuditInstanceListFilterModel implements IFilterList {
    static statusList(): IAuditStatusListEnumDescription[] {
        return [
            { enum: AuditStatusEnum.COMPLETED, description: getAuditStatusEnumDescription(AuditStatusEnum.COMPLETED) },
            { enum: AuditStatusEnum.ERROR, description: getAuditStatusEnumDescription(AuditStatusEnum.ERROR) },
            { enum: AuditStatusEnum.RUNNING, description: getAuditStatusEnumDescription(AuditStatusEnum.RUNNING) },
            { enum: AuditStatusEnum.WARNING, description: getAuditStatusEnumDescription(AuditStatusEnum.WARNING) },
        ]
    }

    static entityList(): IAuditEntityListEnumDescription[] {
        return [
            { enum: EntityEnum.Product, description: getEntityEnumDescription(EntityEnum.Product) },
            { enum: EntityEnum.Order, description: getEntityEnumDescription(EntityEnum.Order) },
            { enum: EntityEnum.Category, description: getEntityEnumDescription(EntityEnum.Category) },
            { enum: EntityEnum.Brand, description: getEntityEnumDescription(EntityEnum.Brand) },
            { enum: EntityEnum.Channel, description: getEntityEnumDescription(EntityEnum.Channel) },
            { enum: EntityEnum.Store, description: getEntityEnumDescription(EntityEnum.Store) },
            { enum: EntityEnum.System, description: getEntityEnumDescription(EntityEnum.System) },
            { enum: EntityEnum.Payment, description: getEntityEnumDescription(EntityEnum.Payment) },
            { enum: EntityEnum.DeliveryCompany, description: getEntityEnumDescription(EntityEnum.DeliveryCompany) },
            { enum: EntityEnum.Attribute, description: getEntityEnumDescription(EntityEnum.Attribute) },
            { enum: EntityEnum.AttributeValue, description: getEntityEnumDescription(EntityEnum.AttributeValue) },
            { enum: EntityEnum.Store, description: getEntityEnumDescription(EntityEnum.Store) },
            { enum: EntityEnum.Report, description: getEntityEnumDescription(EntityEnum.Report) },
        ]
    }

    static severityList(): IAuditSeverityListEnumDescription[] {
        return [
            { enum: AuditSeverityEnum.LOW, description: getAuditSeverityEnumDescription(AuditSeverityEnum.LOW) },
            { enum: AuditSeverityEnum.MEDIUM, description: getAuditSeverityEnumDescription(AuditSeverityEnum.MEDIUM) },
            { enum: AuditSeverityEnum.HIGH, description: getAuditSeverityEnumDescription(AuditSeverityEnum.HIGH) },
        ]
    }

    static modificationSourceList(): IAuditIntegrationSourceEnumDescription[] {
        return [
            { enum: IntegrationSourceEnum.Backend, description: 'Retaguarda' },
            { enum: IntegrationSourceEnum.Channel, description: 'Canal' },
            { enum: IntegrationSourceEnum.Admin, description: 'Muven' },
        ]
    }

    idEntity: string = ''
    custom: boolean = false
    description: string = ''
    clientId: string = ''
    userEmail: string = ''
    date: IDateRange = { start: null, end: null }
    modificationSourceList: IAuditIntegrationSourceEnumDescription[] = []
    severityList: IAuditSeverityListEnumDescription[] = []
    entityList: IAuditEntityListEnumDescription[] = []
    statusList: IAuditStatusListEnumDescription[] = []

    constructor(o?: Partial<AuditInstanceListFilterModel>) {
        Object.assign(this, o)

        this._normalizeEntityList();
        this._emptyStatusListWhenCustom();
    }

    isFilterFilled(): boolean {
        return !!this.description ||
            !!this.date.start ||
            !!this.date.end ||
            !!this.clientId ||
            !!this.userEmail ||
            !!this.modificationSourceList.length ||
            !!this.severityList.length ||
            !!this.entityList.length ||
            !!this.statusList.length
    }

    toPartialQueryString(): string {
        const startDate = this.date ? this.date.start as Date : null
        const endDate = this.date ? this.date.end as Date : null

        const tmp = {
            ...this,
            // clear the date object so it isn't used
            // in the querystring
            date: undefined,
            custom: undefined,
            idEntity: this.idEntity,
            clientId: this.clientId,
            userEmail: this.userEmail,
            entityList: this.entityList.map((e) => {
                return e.enum
            }),
            statusList: this.statusList.map((s) => {
                return s.enum
            }),
            severityList: this.severityList.map((s) => {
                return s.enum
            }),
            modificationSourceList: this.modificationSourceList.map((ms) => {
                return ms.enum
            }),
            startDate: startDate instanceof Date ? startDate.toISOString() : null,
            endDate: endDate instanceof Date ? endDate.toISOString() : null,
        }

        return toPartialQueryString(tmp);
    }

    private _normalizeEntityList(): void {
        if (typeof this.entityList === "string") {
            const splitEntity = (this.entityList as string).split(',') as unknown as EntityEnum[]

            this.entityList = [
                {
                    enum: splitEntity[0],
                    description: this._getSpecificEntityInList(splitEntity[0]),
                }
            ]
        }
    }

    private _emptyStatusListWhenCustom(): void {
        if (this.custom) {
            this.statusList = []
        }
    }

    private _getSpecificEntityInList(entityList: EntityEnum):string {
        return getEntityEnumDescription(entityList)
    }
}
